import { useEffect, useState } from "react";
import { Button, Card, Nav } from "react-bootstrap";
import DeleteCard from "./deleteObject";
import { UpdateStatus } from "../../axios";

export default function AdminCart({
    item,
    taskRedact,
    setWiretapping,
}) {
    const [activeTab, setActiveTab] = useState("#first");
    const handleTabSelect = (eventKey) => {
        setActiveTab(eventKey);
    };
    useEffect(() => {}, [activeTab]);
    const handleStatus = async (id, status) => {
        let result = await UpdateStatus(id, status);
        if (result) {
            setWiretapping();
        }
    };
    return (
        <Card className="card">
            <Card.Header>
                <Nav
                    variant="tabs"
                    defaultActiveKey="#first"
                    onSelect={handleTabSelect}
                >
                    <Nav.Item>
                        <Nav.Link href="#first">
                            <img
                                alt="Аренда73"
                                className="card_i"
                                src="/logo_hom.png"
                            />
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link href="#info">
                            Информация
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link href="#management">
                            Управление
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link className="eve">
                        <img
                                    src={`/img/${
                                        item.status == '1'
                                            ? "eye.svg"
                                            : "eye-off.svg"
                                    }`}
                                    alt=""
                                />
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
            </Card.Header>
            <Card.Body>
                <Card.Title>{item.title}</Card.Title>
                {activeTab === "#first" && (
                    <div className="first">
                          
                        <img
                            src={`/img/product/${item.img}`}
                            alt=""
                        />
                    </div>
                )}
                {activeTab === "#info" && (
                    <div className="info">
                        <h5>Информация: </h5>

                        <ul>
                            <li>
                                <span className="ti">
                                    Адрес:{" "}
                                </span>
                                {item.adres}
                            </li>
                            <li>
                                <span className="ti">
                                    Описание(+description):{" "}
                                </span>
                                {item.description}
                            </li>
                            <li>
                                <span className="ti">
                                    Этаж:{" "}
                                </span>
                                {item.floor}
                            </li>
                            <li>
                                <span className="ti">
                                    {" "}
                                    2ч. -{" "}
                                </span>{" "}
                                {item.hours_1 === null
                                    ? "По умолчанию:1000"
                                    : item.hours_1}
                            </li>
                            <li>
                                <span className="ti">
                                    3ч. -{" "}
                                </span>{" "}
                                {item.hours_2 === null
                                    ? "По умолчанию:1200"
                                    : item.hours_2}
                            </li>
                            <li>
                                <span className="ti">
                                    Ключевые
                                    слова(keywords):{" "}
                                </span>
                                {item.keywords === null
                                    ? " -"
                                    : item.keywords}
                            </li>
                            <li>
                                <span className="ti">
                                    Телефон для связи:
                                </span>
                                {item.phone}
                            </li>
                            <li>
                                <span className="ti">
                                    {" "}
                                    Цена(₽/сут.):{" "}
                                </span>
                                {item.price}
                            </li>
                            <li>
                                <span className="ti">
                                    Колличество комнат:{" "}
                                </span>
                                {item.rooms}
                            </li>
                            <li>
                                <span className="ti">
                                    Площадь:{" "}
                                </span>
                                {item.square}
                            </li>
                        </ul>
                    </div>
                )}
                {activeTab === "#management" && (
                    <div className="management">
                        <h5>Управление записью</h5>
                        <div className="management_box mt-3">
                            <DeleteCard
                                setWiretapping={
                                    setWiretapping
                                }
                                id={item.id}
                            />
                            <Button
                                onClick={() =>
                                    taskRedact(item)
                                }
                            >
                                Редактировать
                            </Button>
                            <Button
                                onClick={() =>
                                    handleStatus(item.id, item.status)
                                }
                            >
                                Отображение{" "}
                                <img
                                    src={`/img/${
                                        item.status == '1'
                                            ? "eye.svg"
                                            : "eye-off.svg"
                                    }`}
                                    alt=""
                                />
                            </Button>
                        </div>
                    </div>
                )}
            </Card.Body>
        </Card>
    );
}
